import { ReactElement } from 'react'
import { CheckedContainerProps } from './props'
import { HiddenInput, StyledCheckedContainer } from './styles'

const CheckedContainer = ({
    children,
    onBlur,
    onFocus,
    ...props
}: CheckedContainerProps): ReactElement => (
    <StyledCheckedContainer onBlur={onBlur} onFocus={onFocus} tabIndex={0}>
        <HiddenInput {...props} />
        {children}
    </StyledCheckedContainer>
)

export default CheckedContainer

export { StyledCheckedContainer }
